import * as z from 'zod'

export const idiomasDisponibles = ['es', 'en', 'pt'] as const satisfies string[]
export const IdiomasDisponiblesZod = z.enum(idiomasDisponibles)
export type IdiomasDisponibles = 'es' | 'en' | 'pt'
